import React from 'react';

const Columns = (setModalConfirm, modalConfirm, openModalAdd) => {

    const columns = [
        {
            id: 'name',
            name: 'Company',
            selector: row => (
                <div className="flex flex-col">
                    <span className="font-medium text-gray-900">
                        {row.name}
                    </span>
                </div>
            ),
        },
        {
            id: 'address',
            name: 'Address',
            selector: row => (
                <span className="text-sm text-gray-600 truncate max-w-[220px] block">
                    {row.address}
                </span>
            ),
        },
        {
            id: 'created_at',
            name: 'Registered',
            selector: row => (
                <span className="text-sm text-gray-500">
                    {row.created_at}
                </span>
            ),
        },
        {
            id: 'plan_name',
            name: 'Subscription',
            selector: row => (
                <span className="text-sm font-medium text-gray-700">
                    {row.plan_name}
                </span>
            ),
        },
        {
            id: 'status',
            name: 'Status',
            button: true,
            cell: row => {
                const base =
                    'inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold';

                const statusStyles = {
                    Active: 'bg-green-100 text-green-700',
                    Trial: 'bg-purple-100 text-purple-700',
                    Inactive: 'bg-red-100 text-red-700',
                };

                return (
                    <span className={`${base} ${statusStyles[row.status_name] || 'bg-gray-100 text-gray-600'}`}>
                        {row.status_name}
                    </span>
                );
            },
        },
        {
            id: 'actions',
            name: '',
            button: true,
            cell: client => (
                <div className="flex items-center gap-2">
                    {/* Edit */}
                    <button
                        onClick={() => openModalAdd(client)}
                        className="w-8 h-8 flex items-center justify-center rounded-full border border-gray-200 hover:bg-gray-100 transition"
                        title="Edit client"
                    >
                        <i className="fas fa-pen text-gray-600 text-sm"></i>
                    </button>

                    {/* Delete */}
                    <button
                        onClick={() =>
                            setModalConfirm({
                                ...modalConfirm,
                                show: true,
                                id: client.id,
                            })
                        }
                        disabled={!client.can?.delete}
                        className={`w-8 h-8 flex items-center justify-center rounded-full border transition
                            ${client.can?.delete
                                ? 'border-red-200 hover:bg-red-50'
                                : 'border-gray-200 opacity-40 cursor-not-allowed'
                            }`}
                        title="Delete client"
                    >
                        <i
                            className={`fas fa-trash text-sm
                                ${client.can?.delete ? 'text-red-500' : 'text-gray-400'}
                            `}
                        ></i>
                    </button>
                </div>
            ),
        },
    ];

    return columns;
};

export default Columns;
